import { FieldValues, UseFormSetError } from 'react-hook-form';
import { handleErrorForm } from '@services/api';
import { Budget } from 'interfaces/Budget';
import { formatCurrency, formatValue } from 'utils/string/currency';
import {
  BudgetIncomeFilters,
  create,
  list,
  remove,
  retrieve,
  update,
} from './calls';

export * from './calls';

export default class BudgetIncomeAPICaller {
  static adaptFromAPI = (data: Budget) =>
    ({
      ...data,
      valueCents: formatCurrency((data.valueCents as number) / 100),
    } as FieldValues);

  static adaptToAPI = (data: FieldValues) => {
    // Math.round: float64 makes many cent values inexact (8.2 * 100 ===
    // 819.9999999999999) and the API column is an integer.
    const valueCents =
      typeof data.valueCents === 'number'
        ? data.valueCents
        : Math.round(formatValue(data.valueCents) * 100);

    const budget = {
      ...data,
      valueCents,
    };

    return budget as Budget;
  };

  static list = async (filters: BudgetIncomeFilters) => {
    const {
      data: { budgets },
    } = await list(filters);

    return { ...budgets, result: budgets.result.map(this.adaptFromAPI) };
  };

  static fetch = async (editId: string) => {
    const {
      data: { budget },
    } = await retrieve(editId);

    // Same adaptation list() applies: the edit form receives valueCents
    // already formatted ("R$ 1.234,56"); adaptToAPI converts it back on save.
    return this.adaptFromAPI(budget);
  };

  static createOrUpdate = async (
    data: FieldValues,
    setError: UseFormSetError<FieldValues>
  ) => {
    const method = data.id ? update : create;

    const result = method(this.adaptToAPI(data)).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
